import { BeneficiarioPagamento } from '../../../models/beneficiario-pagamento';
import { Pagamento } from '../../../models/pagamento';
import { tipiBeneficiarioPagamentoOptions } from '../../../models/tipologiche/mock-tipo-beneficiario';

export class PagamentoUtils {

  public static getBeneficiariAllFromSezionePagamento(pagamenti: Pagamento[]): BeneficiarioPagamento[] {
    let beneficiariAll: BeneficiarioPagamento[] = [];
    for (let pagamento of pagamenti) {
      if (pagamento.controparte) {
        let beneficiarioNew = new BeneficiarioPagamento();
        beneficiarioNew.idParent = pagamento.controparte.id;
        beneficiarioNew.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === '1'; })[0];
        beneficiarioNew.persona = pagamento.controparte.parte;
        beneficiarioNew.categoria = pagamento.controparte.primario ? 'CONTROPARTE PRIMARIA' : 'CONTROPARTE';
        beneficiariAll.push(beneficiarioNew);
      }
      if (pagamento.legaleIncaricato) {
        let beneficiarioNew = new BeneficiarioPagamento();
        beneficiarioNew.idParent = pagamento.legaleIncaricato.id;
        beneficiarioNew.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === '2'; })[0];
        beneficiarioNew.persona = pagamento.legaleIncaricato.legale;
        beneficiarioNew.categoria = pagamento.legaleIncaricato.categoriaLegaleIncaricato ? pagamento.legaleIncaricato.categoriaLegaleIncaricato.label : '';
        beneficiariAll.push(beneficiarioNew);
      }
      if (pagamento.altraParte) {
        let beneficiarioNew = new BeneficiarioPagamento();
        beneficiarioNew.idParent = pagamento.altraParte.id;
        beneficiarioNew.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === '3'; })[0];
        beneficiarioNew.persona = pagamento.altraParte.parte;
        beneficiarioNew.categoria = pagamento.altraParte.categoriaAltraParte ? pagamento.altraParte.categoriaAltraParte.label : '';      
        beneficiariAll.push(beneficiarioNew);
      }
    }
    return beneficiariAll;
  }

}
